import React, { useState } from 'react';
import './FAQ.css';

interface FAQItem {
  question: string;
  answer: string;
}

const FAQ: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs: FAQItem[] = [
    {
      question: "What AI training programs does Global Sansys offer?",
      answer: "Global Sansys offers comprehensive AI training programs including Machine Learning, Deep Learning, Python Programming, TensorFlow, PyTorch, Cloud Computing (AWS, Azure, Google Cloud), and MLOps. Our programs are designed for B.Tech and MCA students to become industry-ready AI professionals."
    },
    {
      question: "How much does the AI training program cost?",
      answer: "We offer flexible pricing options for our AI training programs. Contact us at +91 8885635672 or email globalsansys@gmail.com for detailed pricing information and current offers. We also provide pilot programs for colleges and universities."
    },
    {
      question: "Where is Global Sansys located?",
      answer: "Global Sansys is located at AP SEZ, Atchutapuram, Visakhapatnam, Andhra Pradesh 531011, India. We serve students and professionals across India with both in-person and online training options."
    },
    {
      question: "How can I enroll in the AI training program?",
      answer: "You can enroll by calling us at +91 8885635672 or +91 7989029878, emailing globalsansys@gmail.com, or visiting our pilot program page. We offer free consultations to help you choose the right learning path."
    },
    {
      question: "What makes Global Sansys different from other AI training providers?",
      answer: "Global Sansys is trusted by 7,000+ students across India. We focus on practical, industry-ready skills with real-world projects, portfolio development, and hands-on experience. Our programs are designed by industry AI practitioners and don't disrupt academic schedules."
    },
    {
      question: "Do you offer placement assistance after completing the AI training?",
      answer: "Yes, we provide comprehensive career support including portfolio development, interview preparation, and industry connections. Our training focuses on making you job-ready from day one with practical projects and real-world experience."
    },
    {
      question: "Can working professionals join the AI training program?",
      answer: "Absolutely! Our AI training programs are designed for both students (B.Tech, MCA) and working professionals looking to upskill or transition into AI roles. We offer flexible schedules to accommodate working professionals."
    },
    {
      question: "What is the duration of the AI training program?",
      answer: "Program duration varies based on the course and learning path you choose. Contact us at +91 8885635672 for detailed information about specific program timelines and schedules that fit your needs."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="faq-section" id="faq">
      <div className="container">
        <div className="faq-header">
          <h2>Frequently Asked Questions</h2>
          <p>Everything you need to know about our AI training programs</p>
        </div>
        
        <div className="faq-list">
          {faqs.map((faq, index) => (
            <div 
              key={index} 
              className={`faq-item ${openIndex === index ? 'active' : ''}`}
              onClick={() => toggleFAQ(index)}
            >
              <div className="faq-question">
                <h3>{faq.question}</h3>
                <span className="faq-icon">{openIndex === index ? '−' : '+'}</span>
              </div>
              {openIndex === index && (
                <div className="faq-answer">
                  <p>{faq.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="faq-cta">
          <p>Still have questions?</p>
          <div className="faq-cta-buttons">
            <a href="tel:+918885635672" className="btn-primary">Call Us: +91 8885635672</a>
            <a href="mailto:globalsansys@gmail.com" className="btn-secondary">Email Us</a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQ;
